import { ofType } from 'redux-observable';
import { catchError, delay, map, switchMap, tap } from 'rxjs/operators';
import { concat, EMPTY, from, of, timer } from 'rxjs';
import { navigate } from '@reach/router';
import {
  CREATE_PROJECT,
  getProjects,
  setLoaders,
  setPopupInfo,
} from '../../index';
import { createProject } from '../../../../../services/http/progetti.http-service';
import { rootConfig } from '../../../../../config/root-config';

const epic = (action$: any) =>
  action$.pipe(
    ofType(CREATE_PROJECT),
    map(({ payload }: any) => payload),
    map((text) => ({
      descriptions: [{ language: rootConfig.language, text }],
    })),
    switchMap((payload: any) =>
      concat(
        of(setLoaders({ categories: true })),
        from(createProject(payload)).pipe(
          switchMap(() => of(getProjects(null))),
          catchError(() => EMPTY)
        ),
        of(setLoaders({ categories: false })).pipe(
          delay(300),
          tap(() => navigate(`${rootConfig.app_path}/database/pratiche`))
        ),
        of(
          setPopupInfo({
            opened: true,
            message: 'Creato con successo.',
          })
        ),
        timer(3000).pipe(
          switchMap(() =>
            of(
              setPopupInfo({
                opened: false,
                message: '',
              })
            )
          )
        )
      )
    )
  );

export default epic;
